import createReducer from "../../reducers/createReducer";
import {
  PAYMENT_LIST_LOADING,
  PAYMENT_LIST_SUCCESS,
  PAYMENT_LIST_ERROR,
  GET_PAYMENT_LOADING,
  GET_PAYMENT_SUCCESS,
  GET_PAYMENT_ERROR,
  MONTHS_TO_SETTLE_LOADING,
  MONTHS_TO_SETTLE_SUCCESS,
  MONTHS_TO_SETTLE_ERROR,
  BULK_MONTHS_TO_SETTLE_LOADING,
  BULK_MONTHS_TO_SETTLE_SUCCESS,
  BULK_MONTHS_TO_SETTLE_ERROR,
  SETTLE_PAYMENT_LOADING,
  SETTLE_PAYMENT_SUCCESS,
  SETTLE_PAYMENT_ERROR,
  SETTLE_SALARY_LOADING,
  SETTLE_SALARY_SUCCESS,
  SETTLE_SALARY_ERROR,
  BULK_SETTLE_SALARY_LOADING,
  BULK_SETTLE_SALARY_SUCCESS,
  BULK_SETTLE_SALARY_ERROR,
  COMPANY_LIST_LOADING,
  COMPANY_LIST_SUCCESS,
  COMPANY_LIST_ERROR,
  GET_COMPANY_LOADING,
  GET_COMPANY_SUCCESS,
  GET_COMPANY_ERROR,
  EMPLOYEE_LIST_LOADING,
  EMPLOYEE_LIST_SUCCESS,
  EMPLOYEE_LIST_ERROR,
  GET_EMPLOYEE_LOADING,
  GET_EMPLOYEE_SUCCESS,
  GET_EMPLOYEE_ERROR,
  OVERVIEW_LOADING,
  OVERVIEW_SUCCESS,
  OVERVIEW_ERROR,
  INVITE_COMPANY_LOADING,
  INVITE_COMPANY_SUCCESS,
  INVITE_COMPANY_ERROR,
  UPDATE_COMPANY_LOADING,
  UPDATE_COMPANY_SUCCESS,
  UPDATE_COMPANY_ERROR,
  EXCHANGE_LIST_LOADING,
  EXCHANGE_LIST_SUCCESS,
  EXCHANGE_LIST_ERROR,
  GET_EXCHANGE_LOADING,
  GET_EXCHANGE_SUCCESS,
  GET_EXCHANGE_ERROR,
  CREATE_EXCHANGE_LOADING,
  CREATE_EXCHANGE_SUCCESS,
  CREATE_EXCHANGE_ERROR,
  UPDATE_EXCHANGE_LOADING,
  UPDATE_EXCHANGE_SUCCESS,
  UPDATE_EXCHANGE_ERROR,
  DELETE_EXCHANGE_LOADING,
  DELETE_EXCHANGE_SUCCESS,
  DELETE_EXCHANGE_ERROR,
  BACKOFFICE_DEDUCTION_LIST_LOADING,
  BACKOFFICE_DEDUCTION_LIST_SUCCESS,
  BACKOFFICE_DEDUCTION_LIST_ERROR,
  GET_DEDUCTION_LOADING,
  GET_DEDUCTION_SUCCESS,
  GET_DEDUCTION_ERROR,
  CREATE_DEDUCTION_LOADING,
  CREATE_DEDUCTION_SUCCESS,
  CREATE_DEDUCTION_ERROR,
  UPDATE_DEDUCTION_LOADING,
  UPDATE_DEDUCTION_SUCCESS,
  UPDATE_DEDUCTION_ERROR,
  DELETE_DEDUCTION_LOADING,
  DELETE_DEDUCTION_SUCCESS,
  DELETE_DEDUCTION_ERROR,
  BONUS_LIST_LOADING,
  BONUS_LIST_SUCCESS,
  BONUS_LIST_ERROR,
  GET_BONUS_LOADING,
  GET_BONUS_SUCCESS,
  GET_BONUS_ERROR,
  CREATE_BONUS_LOADING,
  CREATE_BONUS_SUCCESS,
  CREATE_BONUS_ERROR,
  UPDATE_BONUS_LOADING,
  UPDATE_BONUS_SUCCESS,
  UPDATE_BONUS_ERROR,
  DELETE_BONUS_LOADING,
  DELETE_BONUS_SUCCESS,
  DELETE_BONUS_ERROR,
  BONUS_CLAIM_LIST_LOADING,
  BONUS_CLAIM_LIST_SUCCESS,
  BONUS_CLAIM_LIST_ERROR,
  GET_BONUS_CLAIM_LOADING,
  GET_BONUS_CLAIM_SUCCESS,
  GET_BONUS_CLAIM_ERROR,
  DELETE_BONUS_CLAIM_LOADING,
  DELETE_BONUS_CLAIM_SUCCESS,
  DELETE_BONUS_CLAIM_ERROR,
  OVERVIEW_FILTER_SUCCESS,
  TRANSACTIONS_WITHDRAWAL_REQUESTS_FILTER_SUCCESS,
  TRANSACTIONS_OVERTIME_REQUESTS_FILTER_SUCCESS,
  TRANSACTION_HISTORY_LOADING,
  TRANSACTION_HISTORY_SUCCESS,
  TRANSACTION_HISTORY_ERROR,
  BACKOFFICE_COUNTRY_FEES_LIST_LOADING,
  BACKOFFICE_COUNTRY_FEES_LIST_SUCCESS,
  BACKOFFICE_COUNTRY_FEES_LIST_ERROR,
  CREATE_COUNTRY_FEES_LOADING,
  CREATE_COUNTRY_FEES_SUCCESS,
  CREATE_COUNTRY_FEES_ERROR,
  UPDATE_COUNTRY_FEES_LOADING,
  UPDATE_COUNTRY_FEES_SUCCESS,
  UPDATE_COUNTRY_FEES_ERROR,
  PAYMENT_DOWNLOAD_LOADING,
  PAYMENT_DOWNLOAD_SUCCESS,
  PAYMENT_DOWNLOAD_ERROR,
  DASHBOARD_LOADING_ACTION,
  PAYMENT_SUB_TABLE_LIST_ERROR,
  PAYMENT_SUB_TABLE_LIST_LOADING,
  PAYMENT_SUB_TABLE_LIST_SUCCESS,
  DECLINE_PAYMENT_LOADING,
  DECLINE_PAYMENT_ERROR,
  DECLINE_PAYMENT_SUCCESS,
  GET_REPORTS_LOADING,
  GET_REPORTS_ERROR,
  GET_REPORTS_SUCCESS,
  PUSH_NOTFICATION_SUCCESS,
  PUSH_NOTIFICATION_ERROR,
  PUSH_NOTIFICATION_LOADING,
  SEND_MONTHLY_COMPANY_REPORTS_ERROR,
  SEND_MONTHLY_COMPANY_REPORTS_LOADING,
  SEND_MONTHLY_COMPANY_REPORTS_SUCCESS,
  SEND_CUSTOM_COMPANY_REPORTS_ERROR,
  SEND_CUSTOM_COMPANY_REPORTS_LOADING,
  SEND_CUSTOM_COMPANY_REPORTS_SUCCESS,
  GET_PAYMENTS_COUNT_ERROR,
  GET_PAYMENTS_COUNT_LOADING,
  GET_PAYMENTS_COUNT_SUCCESS,
  UPDATE_COMPANY_PAYMENT_LOADING,
  UPDATE_COMPANY_PAYMENT_ERROR,
  UPDATE_COMPANY_PAYMENT_SUCCESS,
  GET_WITHDRAWAL_CATEGORIES_ERROR,
  GET_WITHDRAWAL_CATEGORIES_LOADING,
  GET_WITHDRAWAL_CATEGORIES_SUCCESS,
  UPDATE_WITHDRAWAL_CATEGORY_ERROR,
  UPDATE_WITHDRAWAL_CATEGORY_LOADING,
  UPDATE_WITHDRAWAL_CATEGORY_SUCCESS,
  CREATE_WITHDRAWAL_CATEGORY_LOADING,
  CREATE_WITHDRAWAL_CATEGORY_ERROR,
  CREATE_WITHDRAWAL_CATEGORY_SUCCESS,
  DELETE_WITHDRAWAL_CATEGORY_ERROR,
  DELETE_WITHDRAWAL_CATEGORY_SUCCESS,
  DELETE_WITHDRAWAL_CATEGORY_LOADING,
  GET_WITHDRAWAL_CATEGORY_SUCCESS,
  GET_WITHDRAWAL_CATEGORY_LOADING,
  GET_WITHDRAWAL_CATEGORY_ERROR,
  MERCHANT_LIST_LOADING,
  MERCHANT_LIST_SUCCESS,
  MERCHANT_LIST_ERROR,
  GET_MERCHANT_LOADING,
  GET_MERCHANT_SUCCESS,
  GET_MERCHANT_ERROR,
  INVITE_MERCHANT_LOADING,
  INVITE_MERCHANT_SUCCESS,
  INVITE_MERCHANT_ERROR,
  UPDATE_MERCHANT_LOADING,
  UPDATE_MERCHANT_SUCCESS,
  UPDATE_MERCHANT_ERROR,
  REACTIVATE_VENDOR_LOADING,
  REACTIVATE_VENDOR_SUCCESS,
  REACTIVATE_VENDOR_ERROR,
  SUSPEND_VENDOR_LOADING,
  SUSPEND_VENDOR_SUCCESS,
  SUSPEND_VENDOR_ERROR,
  PROMOTE_HR_TO_ADMIN_ERROR,
  PROMOTE_HR_TO_ADMIN_LOADING,
  PROMOTE_HR_TO_ADMIN_SUCCESS,
  GET_USER_ACTIVITY_LOGS_ERROR,
  GET_USER_ACTIVITY_LOGS_SUCCESS,
  GET_USER_ACTIVITY_LOGS_LOADING,
  GET_VENDOR_PAYMENTS_ACTION,
  GET_VENDOR_PAYMENTS_LOADING,
  GET_VENDOR_PAYMENTS_SUCCESS,
  GET_VENDOR_PAYMENTS_ERROR,
  GET_VENDOR_FEES_LOADING,
  GET_VENDOR_FEES_SUCCESS,
  GET_VENDOR_FEES_ERROR,
  CREATE_VENDOR_FEES_LOADING,
  CREATE_VENDOR_FEES_SUCCESS,
  CREATE_VENDOR_FEES_ERROR,
  UPDATE_VENDOR_FEES_LOADING,
  UPDATE_VENDOR_FEES_SUCCESS,
  UPDATE_VENDOR_FEES_ERROR,
  DELETE_VENDOR_FEES_LOADING,
  DELETE_VENDOR_FEES_SUCCESS,
  DELETE_VENDOR_FEES_ERROR,
  GET_COMPANY_FEES_LOADING,
  GET_COMPANY_FEES_SUCCESS,
  GET_COMPANY_FEES_ERROR,
  CREATE_COMPANY_FEES_LOADING,
  CREATE_COMPANY_FEES_SUCCESS,
  CREATE_COMPANY_FEES_ERROR,
  UPDATE_COMPANY_FEES_LOADING,
  UPDATE_COMPANY_FEES_SUCCESS,
  UPDATE_COMPANY_FEES_ERROR,
  DELETE_COMPANY_FEES_LOADING,
  DELETE_COMPANY_FEES_SUCCESS,
  DELETE_COMPANY_FEES_ERROR,
  GET_VENDOR_SETTLEMENTS_LOADING,
  GET_VENDOR_SETTLEMENTS_SUCCESS,
  GET_VENDOR_SETTLEMENTS_ERROR,
  ADD_VENDOR_BANK_DETAILS_LOADING,
  ADD_VENDOR_BANK_DETAILS_SUCCESS,
  ADD_VENDOR_BANK_DETAILS_ERROR,
  UPDATE_VENDOR_BANK_DETAILS_LOADING,
  UPDATE_VENDOR_BANK_DETAILS_SUCCESS,
  UPDATE_VENDOR_BANK_DETAILS_ERROR,
  DELETE_VENDOR_BANK_DETAILS_LOADING,
  DELETE_VENDOR_BANK_DETAILS_SUCCESS,
  DELETE_VENDOR_BANK_DETAILS_ERROR,
  GET_VENDOR_BANK_DETAILS_LOADING,
  GET_VENDOR_BANK_DETAILS_SUCCESS,
  GET_VENDOR_BANK_DETAILS_ERROR,
  LIST_VENDOR_BANK_DETAILS_LOADING,
  LIST_VENDOR_BANK_DETAILS_SUCCESS,
  LIST_VENDOR_BANK_DETAILS_ERROR,
  GET_PAYSTACK_BANKS_LIST_LOADING,
  GET_PAYSTACK_BANKS_LIST_SUCCESS,
  GET_PAYSTACK_BANKS_LIST_ERROR,
  VERIFY_PAYSTACK_BANK_ACCOUNT_LOADING,
  VERIFY_PAYSTACK_BANK_ACCOUNT_SUCCESS,
  VERIFY_PAYSTACK_BANK_ACCOUNT_ERROR,
  VENDOR_SETTLEMENT_TRIGGER_ERROR,
  VENDOR_SETTLEMENT_TRIGGER_SUCCESS,
  VENDOR_SETTLEMENT_TRIGGER_LOADING,
  VENDOR_RESEND_INVITATION_ERROR,
  VENDOR_RESEND_INVITATION_SUCCESS,
  VENDOR_RESEND_INVITATION_LOADING,
  VENDOR_SETTLEMENT_TRIGGER_AGGREGATE_ERROR,
  VENDOR_SETTLEMENT_TRIGGER_AGGREGATE_SUCCESS,
  VENDOR_SETTLEMENT_TRIGGER_AGGREGATE_LOADING,
  ONBOARD_COMPANY_EMPLOYEES_ERROR,
  ONBOARD_COMPANY_EMPLOYEES_SUCCESS,
  ONBOARD_COMPANY_EMPLOYEES_LOADING,
  CAMPAIGN_CONFIG_REQUEST_LOADING,
  CAMPAIGN_CONFIG_REQUEST_SUCCESS,
  CAMPAIGN_CONFIG_REQUEST_ERROR,
  CAMPAIGN_LIST_REQUEST_LOADING,
  CAMPAIGN_LIST_REQUEST_SUCCESS,
  CAMPAIGN_LIST_REQUEST_ERROR,
  CAMPAIGN_DETAIL_REQUEST_LOADING,
  CAMPAIGN_DETAIL_REQUEST_SUCCESS,
  CAMPAIGN_DETAIL_REQUEST_ERROR,
  CAMPAIGN_CREATE_REQUEST_LOADING,
  CAMPAIGN_CREATE_REQUEST_SUCCESS,
  CAMPAIGN_CREATE_REQUEST_ERROR,
  CAMPAIGN_UPDATE_REQUEST_LOADING,
  CAMPAIGN_UPDATE_REQUEST_SUCCESS,
  CAMPAIGN_UPDATE_REQUEST_ERROR,
  CAMPAIGN_ACTION_REQUEST_LOADING,
  CAMPAIGN_ACTION_REQUEST_SUCCESS,
  CAMPAIGN_ACTION_REQUEST_ERROR,
  CAMPAIGN_STATS_REQUEST_LOADING,
  CAMPAIGN_STATS_REQUEST_SUCCESS,
  CAMPAIGN_STATS_REQUEST_ERROR,
  CAMPAIGN_HISTORY_REQUEST_LOADING,
  CAMPAIGN_HISTORY_REQUEST_SUCCESS,
  CAMPAIGN_HISTORY_REQUEST_ERROR,
  CAMPAIGN_SET_FILTERS_SUCCESS,
  CAMPAIGN_SET_PAGINATION_SUCCESS,
  CAMPAIGN_SET_HISTORY_PAGINATION_SUCCESS,
  CAMPAIGN_RESET_FORM_ERRORS_SUCCESS,
  CAMPAIGN_CLEAR_TOAST_SUCCESS,
  PERMISSION_CATALOGUE_LOADING,
  PERMISSION_CATALOGUE_SUCCESS,
  PERMISSION_CATALOGUE_ERROR,
  GROUP_LIST_LOADING,
  GROUP_LIST_SUCCESS,
  GROUP_LIST_ERROR,
  GET_GROUP_LOADING,
  GET_GROUP_SUCCESS,
  GET_GROUP_ERROR,
  CREATE_GROUP_LOADING,
  CREATE_GROUP_SUCCESS,
  CREATE_GROUP_ERROR,
  UPDATE_GROUP_LOADING,
  UPDATE_GROUP_SUCCESS,
  UPDATE_GROUP_ERROR,
  DELETE_GROUP_LOADING,
  DELETE_GROUP_SUCCESS,
  DELETE_GROUP_ERROR,
  GROUP_MEMBER_LIST_LOADING,
  GROUP_MEMBER_LIST_SUCCESS,
  GROUP_MEMBER_LIST_ERROR,
  ADD_GROUP_MEMBERS_LOADING,
  ADD_GROUP_MEMBERS_SUCCESS,
  ADD_GROUP_MEMBERS_ERROR,
  REMOVE_GROUP_MEMBERS_LOADING,
  REMOVE_GROUP_MEMBERS_SUCCESS,
  REMOVE_GROUP_MEMBERS_ERROR,
  NOTIFICATION_COUNT_SUCCESS,
  NOTIFICATION_COUNT_ERROR,
  NOTIFICATION_LIST_LOADING,
  NOTIFICATION_LIST_SUCCESS,
  NOTIFICATION_LIST_ERROR,
  MARK_NOTIFICATION_READ_SUCCESS,
  MARK_ALL_NOTIFICATIONS_READ_SUCCESS,
  GET_FORTRESS_COMPANIES_LOADING,
  GET_FORTRESS_COMPANIES_SUCCESS,
  GET_FORTRESS_COMPANIES_ERROR,
  UPDATE_FORTRESS_COMPANIES_LOADING,
  UPDATE_FORTRESS_COMPANIES_SUCCESS,
  UPDATE_FORTRESS_COMPANIES_ERROR,
  FORTRESS_BANK_CODE_LIST_LOADING,
  FORTRESS_BANK_CODE_LIST_SUCCESS,
  FORTRESS_BANK_CODE_LIST_ERROR,
  UPDATE_FORTRESS_BANK_CODE_LOADING,
  UPDATE_FORTRESS_BANK_CODE_SUCCESS,
  UPDATE_FORTRESS_BANK_CODE_ERROR,
  DOWNLOAD_EMPLOYEE_STATEMENT_LOADING,
  DOWNLOAD_EMPLOYEE_STATEMENT_SUCCESS,
  DOWNLOAD_EMPLOYEE_STATEMENT_ERROR,
} from "./types";
import { SIGN_OUT_SUCCESS } from "../login/types";
let initialState = {
  loading: false,
  error: null,
  success: null,
  // Employee payment-statement PDF download (backoffice). error payload is
  // { messages: string[], details: { start_time?, end_time? }, status }.
  downloadEmployeeStatementLoading: false,
  downloadEmployeeStatementSuccess: null,
  downloadEmployeeStatementError: null,
  inviteCompanyError: null,
  // Payment-gateway config (Fortress) — super-only.
  fortressCompanies: [],
  fortressCompaniesLoading: false,
  fortressCompaniesError: null,
  updateFortressCompaniesLoading: false,
  updateFortressCompaniesSuccess: null,
  updateFortressCompaniesError: null,
  fortressBankCodes: null,
  fortressBankCodesLoading: false,
  fortressBankCodesError: null,
  updateFortressBankCodeLoading: false,
  updateFortressBankCodeSuccess: null,
  updateFortressBankCodeError: null,
  fortressBankCodeFieldErrors: null,
  paymentList: [],
  paymentInfo: null,
  companyList: null,
  companyInfo: null,
  employeeList: [],
  employeeInfo: null,
  companyOverview: null,
  exchangeList: [],
  exchangeInfo: null,
  bulkMonthsToSettle: [],
  monthsToSettle: [],
  createExchangeSuccess: null,
  createExchangeError: null,
  updateExchangeSuccess: null,
  updateExchangeError: null,
  deleteExchangeSuccess: null,
  deleteExchangeError: null,
  deductionList: [],
  deductionInfo: null,
  createDeductionSuccess: null,
  createDeductionError: null,
  updateDeductionSuccess: null,
  updateDeductionError: null,
  deleteDeductionSuccess: null,
  deleteDeductionError: null,
  // Bonuses (admin)
  bonusList: null,
  bonusListLoading: false,
  bonusListError: null,
  bonusInfo: null,
  bonusInfoLoading: false,
  bonusInfoError: null,
  createBonusSuccess: null,
  createBonusError: null,
  updateBonusSuccess: null,
  updateBonusError: null,
  deleteBonusSuccess: null,
  deleteBonusError: null,
  bonusMutationLoading: false,
  bonusFormFieldErrors: null,
  // Bonus claims (admin)
  bonusClaimList: null,
  bonusClaimListLoading: false,
  bonusClaimListError: null,
  bonusClaimInfo: null,
  bonusClaimInfoLoading: false,
  bonusClaimInfoError: null,
  deleteBonusClaimSuccess: null,
  deleteBonusClaimError: null,
  deleteBonusClaimLoading: false,
  // Role Groups
  permissionCatalogue: [],
  permissionCatalogueLoading: false,
  permissionCatalogueError: null,
  groupList: null,
  groupListLoading: false,
  groupListError: null,
  groupDetail: null,
  groupDetailLoading: false,
  groupDetailError: null,
  createGroupSuccess: null,
  createGroupError: null,
  updateGroupSuccess: null,
  updateGroupError: null,
  deleteGroupSuccess: null,
  deleteGroupError: null,
  groupMutationLoading: false,
  groupFormFieldErrors: null,
  // Group members
  groupMembersList: null,
  groupMembersLoading: false,
  groupMembersError: null,
  addMembersSuccess: null,
  addMembersError: null,
  removeMembersSuccess: null,
  removeMembersError: null,
  memberMutationLoading: false,
  // Notifications (current user)
  notificationCount: { unread: 0, total: 0 },
  notificationList: null,
  notificationListLoading: false,
  notificationListError: null,
  overviewFilters: null,
  withdrawalRequestsFilters: null,
  overtimeRequestsFilters: null,
  transactionHistory: [],
  countryFeesList: [],
  createCountryFeesSuccess: null,
  createCountryFeesError: null,
  updateCountryFeesSuccess: null,
  updateCountryFeesError: null,
  paymentSubTableList: [],
  paymentSubTablePage: 1,
  paymentSubTableListError: null,
  reportAnalysisData: {

  },
  companyMonthlyReportsSuccess: null,
  companyMonthlyReportsError: null,
  companyCustomReportsSuccess: null,
  companyCustomReportsError: null,
  paymentCountNo: null,
  paymentCountNoLoading: false,
  paymentCountNoError: null,
  updateCompanyPaymentLoading: false,
  updateCompanyPaymentSuccess: null,
  updateCompanyPaymentError: null,
  withdrawalLimitCategories: {},
  withdrawalLimitCategoryInfo: null,
  updateWithdrawalLimitCategory: null,
  updateWithdrawalLimitCategoryError: null,
  deleteWithdrawalLimitCategoryError: null,
  deleteWithdrawalLimitCategorySuccess: null,
  createWithdrawalLimitCategorySuccess: null,
  createWithdrawalLimitCategoryError: null,
  merchantList: null,
  merchantInfo: null,
  vendorPayments: null,
  vendorFees: null,
  createVendorFeesSuccess: null,
  createVendorFeesError: null,
  updateVendorFeesSuccess: null,
  updateVendorFeesError: null,
  deleteVendorFeesSuccess: null,
  deleteVendorFeesError: null,
  companyFees: null,
  createCompanyFeesSuccess: null,
  createCompanyFeesError: null,
  updateCompanyFeesSuccess: null,
  updateCompanyFeesError: null,
  deleteCompanyFeesSuccess: null,
  deleteCompanyFeesError: null,
  vendorSettlements: {
    count: 0,
    next: null,
    previous: null,
    data: [],
  },
  inviteMerchantSuccess: null,
  inviteMerchantError: null,
  updateMerchantSuccess: null,
  updateMerchantError: null,
  promoteHRToAdmin: null,
  usersActivityLogs: {
    isLoading: false,
    res: {},
    error: null
  },
  addVendorBankDetailsSuccess: null,
  addVendorBankDetailsError: null,
  updateVendorBankDetailsSuccess: null,
  updateVendorBankDetailsError: null,
  deleteVendorBankDetailsSuccess: null,
  deleteVendorBankDetailsError: null,
  getVendorBankDetailsSuccess: null,
  getVendorBankDetailsError: null,
  getVendorBankDetailsLoading: false,
  getVendorBankDetails: null,
  updateVendorBankDetails: null,
  addVendorBankDetailsLoading: false,
  updateVendorBankDetailsLoading: false,
  deleteVendorBankDetailsLoading: false,
  getVendorBankDetailsLoading: false,
  addVendorBankDetails: null,
  updateVendorBankDetails: null,
  deleteVendorBankDetails: null,
  getVendorBankDetails: null,
  listVendorBankDetailsSuccess: null,
  listVendorBankDetailsError: null,
  listVendorBankDetailsLoading: false,
  listVendorBankDetails: null,
  paystackBanksList: {
    isLoading: false,
    res: {},
    error: null
  },
  verifyPaystackBankAccount: {
    isLoading: false,
    res: {},
    error: null
  },
  vendorSettlementTriggerLoading: false,
  vendorSettlementTriggerSuccess: null,
  vendorSettlementTriggerError: null,
  vendorResendInvitationLoading: false,
  vendorResendInvitationSuccess: null,
  vendorResendInvitationError: null,
  vendorSettlementTriggerAggregateLoading: false,
  vendorSettlementTriggerAggregateSuccess: null,
  vendorSettlementTriggerAggregateError: null,
  onboardCompanyEmployeesLoading: false,
  onboardCompanyEmployeesSuccess: null,
  onboardCompanyEmployeesError: null,
  campaigns: {
    configLoading: false,
    listLoading: false,
    detailLoading: false,
    saveLoading: false,
    actionLoading: false,
    statsLoading: false,
    historyLoading: false,
    config: null,
    list: { count: 0, next: null, previous: null, data: [] },
    detail: null,
    stats: null,
    history: { count: 0, next: null, previous: null, data: [] },
    filters: {
      state: "",
      campaign_type: "",
      is_enabled: "",
      country: "",
      search: "",
    },
    pagination: {
      page: 1,
      page_size: 10,
    },
    historyPagination: {
      page: 1,
      page_size: 10,
    },
    formErrors: null,
    error: null,
    toast: null,
  },
};

function resolveState(state = {}, newState = {}) {
  return Object.assign({}, state, newState)
}

export const dashboardReducer = createReducer(initialState, {
  /* ── Payment-gateway config (Fortress) ──────────────────────────────── */
  [GET_FORTRESS_COMPANIES_LOADING](state) {
    return Object.assign({}, state, {
      fortressCompaniesLoading: true,
      fortressCompaniesError: null,
    });
  },
  [GET_FORTRESS_COMPANIES_SUCCESS](state, action) {
    return Object.assign({}, state, {
      fortressCompaniesLoading: false,
      fortressCompanies: action.payload || [],
      fortressCompaniesError: null,
    });
  },
  [GET_FORTRESS_COMPANIES_ERROR](state, action) {
    return Object.assign({}, state, {
      fortressCompaniesLoading: false,
      fortressCompaniesError: action.payload,
    });
  },
  [UPDATE_FORTRESS_COMPANIES_LOADING](state) {
    return Object.assign({}, state, {
      updateFortressCompaniesLoading: true,
      updateFortressCompaniesSuccess: null,
      updateFortressCompaniesError: null,
    });
  },
  [UPDATE_FORTRESS_COMPANIES_SUCCESS](state, action) {
    // Reused as a resetter: dispatching with null clears the success flag WITHOUT
    // touching the saved set. Never coerce null -> [] (that keeps the flag truthy
    // and loops the success effect, and would wipe fortressCompanies).
    const hasPayload = action.payload != null;
    return Object.assign({}, state, {
      updateFortressCompaniesLoading: false,
      updateFortressCompaniesSuccess: action.payload,
      // Reconcile the current set only from a real PUT response.
      fortressCompanies: hasPayload ? action.payload : state.fortressCompanies,
      updateFortressCompaniesError: null,
    });
  },
  [UPDATE_FORTRESS_COMPANIES_ERROR](state, action) {
    return Object.assign({}, state, {
      updateFortressCompaniesLoading: false,
      updateFortressCompaniesSuccess: null,
      updateFortressCompaniesError: action.payload,
    });
  },
  [FORTRESS_BANK_CODE_LIST_LOADING](state) {
    return Object.assign({}, state, {
      fortressBankCodesLoading: true,
      fortressBankCodesError: null,
    });
  },
  [FORTRESS_BANK_CODE_LIST_SUCCESS](state, action) {
    return Object.assign({}, state, {
      fortressBankCodesLoading: false,
      fortressBankCodes: action.payload,
      fortressBankCodesError: null,
    });
  },
  [FORTRESS_BANK_CODE_LIST_ERROR](state, action) {
    return Object.assign({}, state, {
      fortressBankCodesLoading: false,
      fortressBankCodesError: action.payload,
    });
  },
  [UPDATE_FORTRESS_BANK_CODE_LOADING](state) {
    return Object.assign({}, state, {
      updateFortressBankCodeLoading: true,
      updateFortressBankCodeSuccess: null,
      updateFortressBankCodeError: null,
      fortressBankCodeFieldErrors: null,
    });
  },
  [UPDATE_FORTRESS_BANK_CODE_SUCCESS](state, action) {
    return Object.assign({}, state, {
      updateFortressBankCodeLoading: false,
      updateFortressBankCodeSuccess: action.payload,
      updateFortressBankCodeError: null,
      fortressBankCodeFieldErrors: null,
    });
  },
  [UPDATE_FORTRESS_BANK_CODE_ERROR](state, action) {
    return Object.assign({}, state, {
      updateFortressBankCodeLoading: false,
      updateFortressBankCodeSuccess: null,
      updateFortressBankCodeError: action.payload,
      fortressBankCodeFieldErrors: action.fieldErrors || null,
    });
  },
  [ONBOARD_COMPANY_EMPLOYEES_ERROR](state, action) {
    return resolveState(state, {
      onboardCompanyEmployeesLoading: false,
      onboardCompanyEmployeesSuccess: null,
      onboardCompanyEmployeesError: action.payload
    })
  },
  [ONBOARD_COMPANY_EMPLOYEES_SUCCESS](state, action) {
    return resolveState(state, {
      onboardCompanyEmployeesLoading: false,
      onboardCompanyEmployeesSuccess: action.payload,
      onboardCompanyEmployeesError: null
    })
  },
  [ONBOARD_COMPANY_EMPLOYEES_LOADING](state, action) {
    return resolveState(state, {
      onboardCompanyEmployeesLoading: true,
      onboardCompanyEmployeesSuccess: null,
      onboardCompanyEmployeesError: null
    })
  },
  [VENDOR_SETTLEMENT_TRIGGER_AGGREGATE_SUCCESS](state, action) {
    return resolveState(state, {
      vendorSettlementTriggerAggregateSuccess: action.payload,
      vendorSettlementTriggerAggregateError: null,
      vendorSettlementTriggerAggregateLoading: false,
    })
  },
  [VENDOR_SETTLEMENT_TRIGGER_AGGREGATE_ERROR](state, action) {
    return resolveState(state, {
      vendorSettlementTriggerAggregateSuccess: null,
      vendorSettlementTriggerAggregateError: action.payload,
      vendorSettlementTriggerAggregateLoading: false,
    })
  },
  [VENDOR_SETTLEMENT_TRIGGER_AGGREGATE_LOADING](state, action) {
    return resolveState(state, {
      vendorSettlementTriggerAggregateSuccess: null,
      vendorSettlementTriggerAggregateError: null,
      vendorSettlementTriggerAggregateLoading: true,
    })
  },
  [VENDOR_RESEND_INVITATION_SUCCESS](state, action) {
    return resolveState(state, {
      vendorResendInvitationSuccess: action.payload,
      vendorResendInvitationError: null,
      vendorResendInvitationLoading: false,
    })
  },
  [VENDOR_RESEND_INVITATION_ERROR](state, action) {
    return resolveState(state, {
      vendorResendInvitationSuccess: null,
      vendorResendInvitationError: action.payload,
      vendorResendInvitationLoading: false,
    })
  },
  [VENDOR_RESEND_INVITATION_LOADING](state, action) {
    return resolveState(state, {
      vendorResendInvitationSuccess: null,
      vendorResendInvitationError: null,
      vendorResendInvitationLoading: true,
    })
  },
  [VENDOR_SETTLEMENT_TRIGGER_SUCCESS](state, action) {
    return resolveState(state, {
      vendorSettlementTriggerSuccess: action.payload,
      vendorSettlementTriggerError: null,
      vendorSettlementTriggerLoading: false,
    })
  },
  [VENDOR_SETTLEMENT_TRIGGER_ERROR](state, action) {
    return resolveState(state, {
      vendorSettlementTriggerSuccess: null,
      vendorSettlementTriggerError: action.payload,
      vendorSettlementTriggerLoading: false,
    })
  },
  [VENDOR_SETTLEMENT_TRIGGER_LOADING](state, action) {
    return resolveState(state, {
      vendorSettlementTriggerSuccess: null,
      vendorSettlementTriggerError: null,
      vendorSettlementTriggerLoading: true,
    })
  },
  [LIST_VENDOR_BANK_DETAILS_SUCCESS](state, action) {
    return resolveState(state, {
      listVendorBankDetailsSuccess: action.payload,
      listVendorBankDetailsError: null,
      listVendorBankDetailsLoading: false,
    })
  },
  [LIST_VENDOR_BANK_DETAILS_ERROR](state, action) {
    return resolveState(state, {
      listVendorBankDetailsSuccess: null,
      listVendorBankDetailsError: action.payload,
      listVendorBankDetailsLoading: false,
    })
  },
  [LIST_VENDOR_BANK_DETAILS_LOADING](state, action) {
    return resolveState(state, {
      listVendorBankDetailsSuccess: null,
      listVendorBankDetailsError: null,
      listVendorBankDetailsLoading: true,
    })
  },
  [ADD_VENDOR_BANK_DETAILS_SUCCESS](state, action) {
    return resolveState(state, {
      addVendorBankDetailsSuccess: action.payload,
      addVendorBankDetailsError: null,
      addVendorBankDetailsLoading: false,
    })
  },
  [ADD_VENDOR_BANK_DETAILS_ERROR](state, action) {
    return resolveState(state, {  
      addVendorBankDetailsSuccess: null,
      addVendorBankDetailsError: action.payload,
      addVendorBankDetailsLoading: false,
    })
  },
  [ADD_VENDOR_BANK_DETAILS_LOADING](state, action) {
    return resolveState(state, {
      addVendorBankDetailsSuccess: null,
      addVendorBankDetailsError: null,
      addVendorBankDetailsLoading: true,
    })
  },
  [UPDATE_VENDOR_BANK_DETAILS_SUCCESS](state, action) {
    return resolveState(state, {
      updateVendorBankDetailsSuccess: action.payload,
      updateVendorBankDetailsError: null,
      updateVendorBankDetailsLoading: false,
    })
  },
  [UPDATE_VENDOR_BANK_DETAILS_ERROR](state, action) {
    return resolveState(state, {
      updateVendorBankDetailsSuccess: null,
      updateVendorBankDetailsError: action.payload,
      updateVendorBankDetailsLoading: false,
    })
  },
  [UPDATE_VENDOR_BANK_DETAILS_LOADING](state, action) {
    return resolveState(state, {
      updateVendorBankDetailsSuccess: null,
      updateVendorBankDetailsError: null,
      updateVendorBankDetailsLoading: true,
    })
  },
  [DELETE_VENDOR_BANK_DETAILS_SUCCESS](state, action) {
    return resolveState(state, {
      deleteVendorBankDetailsSuccess: action.payload,
      deleteVendorBankDetailsError: null,
      deleteVendorBankDetailsLoading: false,
    })
  },
  [DELETE_VENDOR_BANK_DETAILS_ERROR](state, action) {
    return resolveState(state, {
      deleteVendorBankDetailsSuccess: null,
      deleteVendorBankDetailsError: action.payload,
      deleteVendorBankDetailsLoading: false,
    })
  },
  [DELETE_VENDOR_BANK_DETAILS_LOADING](state, action) {
    return resolveState(state, {
      deleteVendorBankDetailsSuccess: null,
      deleteVendorBankDetailsError: null,
      deleteVendorBankDetailsLoading: true,
    })
  },
  [GET_VENDOR_BANK_DETAILS_SUCCESS](state, action) {
    return resolveState(state, {
      getVendorBankDetailsSuccess: action.payload,
      getVendorBankDetailsError: null,
      getVendorBankDetailsLoading: false,
    })
  },
  [GET_VENDOR_BANK_DETAILS_ERROR](state, action) {
    return resolveState(state, {
      getVendorBankDetailsSuccess: null,
      getVendorBankDetailsError: action.payload,
      getVendorBankDetailsLoading: false,
    })
  },
  [GET_VENDOR_BANK_DETAILS_LOADING](state, action) {
    return resolveState(state, {
      getVendorBankDetailsSuccess: null,
      getVendorBankDetailsError: null,
      getVendorBankDetailsLoading: true,
    })
  },
  [UPDATE_VENDOR_BANK_DETAILS_SUCCESS](state, action) {
    return resolveState(state, {
      updateVendorBankDetailsSuccess: action.payload,
      updateVendorBankDetailsError: null,
      updateVendorBankDetailsLoading: false,
    })
  },
  [UPDATE_VENDOR_BANK_DETAILS_ERROR](state, action) {
    return resolveState(state, {
      updateVendorBankDetailsSuccess: null,
      updateVendorBankDetailsError: action.payload,
      updateVendorBankDetailsLoading: false,
    })
  },
  [UPDATE_VENDOR_BANK_DETAILS_LOADING](state, action) {
    return resolveState(state, {
      updateVendorBankDetailsSuccess: null,
      updateVendorBankDetailsError: null,
      updateVendorBankDetailsLoading: true,
    })
  },
  [DELETE_VENDOR_BANK_DETAILS_SUCCESS](state, action) {
    return resolveState(state, {
      deleteVendorBankDetailsSuccess: action.payload,
      deleteVendorBankDetailsError: null,
      deleteVendorBankDetailsLoading: false,
    })
  },
  [DELETE_VENDOR_BANK_DETAILS_ERROR](state, action) {
    return resolveState(state, {
      deleteVendorBankDetailsSuccess: null,
      deleteVendorBankDetailsError: action.payload,
      deleteVendorBankDetailsLoading: false,
    })
  },
  [DELETE_VENDOR_BANK_DETAILS_LOADING](state, action) {
    return resolveState(state, {
      deleteVendorBankDetailsSuccess: null,
      deleteVendorBankDetailsError: null,
      deleteVendorBankDetailsLoading: true,
    })
  },
  
  [GET_PAYSTACK_BANKS_LIST_ERROR](state, action) {
    return resolveState(state, {
      paystackBanksList: resolveState(
        state.paystackBanksList,
        {
          isLoading: false,
          error: action.payload,
          res: {}
        }
      )
    });
  },
  [GET_PAYSTACK_BANKS_LIST_LOADING](state, action) {
    return resolveState(state, {
      paystackBanksList: resolveState(
        state.paystackBanksList,
        {
          isLoading: true,
          error: null,
        }
      )
    });
  },
  [GET_PAYSTACK_BANKS_LIST_SUCCESS](state, action) {
    return resolveState(state, {
      paystackBanksList: resolveState(
        state.paystackBanksList,
        {
          isLoading: false,
          error: null,
          res: action.payload
        }
      )
    });
  },
  [VERIFY_PAYSTACK_BANK_ACCOUNT_ERROR](state, action) {
    return resolveState(state, {
      verifyPaystackBankAccount: resolveState(
        state.verifyPaystackBankAccount,
        {
          isLoading: false,
          error: action.payload,
          res: {}
        }
      )
    });
  },
  [VERIFY_PAYSTACK_BANK_ACCOUNT_LOADING](state, action) {
    return resolveState(state, {
      verifyPaystackBankAccount: resolveState(
        state.verifyPaystackBankAccount,
        {
          isLoading: true,
          error: null,
        }
      )
    });
  },
  [VERIFY_PAYSTACK_BANK_ACCOUNT_SUCCESS](state, action) {
    return resolveState(state, {
      verifyPaystackBankAccount: resolveState(
        state.verifyPaystackBankAccount,
        {
          isLoading: false,
          error: null,
          res: action.payload
        }
      )
    });
  },
  [PROMOTE_HR_TO_ADMIN_SUCCESS](state, action) {
    return resolveState(state, {
      loading: false,
      promoteHRToAdmin: action.payload,
      error: null
    })
  },
  [PROMOTE_HR_TO_ADMIN_LOADING](state, action) {
    return resolveState(state, {
      loading: true,
      error: null,
      promoteHRToAdmin: null
    })
  },
  [PROMOTE_HR_TO_ADMIN_ERROR](state, action) {
    return resolveState(state, {
      loading: false,
      error: action.payload,
      promoteHRToAdmin: null
    })
  },
  [GET_USER_ACTIVITY_LOGS_ERROR](state, action) {
    return resolveState(state, {
      usersActivityLogs: resolveState(
        state.usersActivityLogs,
        {
          isLoading: false,
          error: action.payload,
          res: {}
        }
      )
    });
  },
  [GET_USER_ACTIVITY_LOGS_LOADING](state, action) {
    return resolveState(state, {
      usersActivityLogs: resolveState(
        state.usersActivityLogs,
        {
          isLoading: true,
          error: null,
        }
      )
    });
  },
  [GET_USER_ACTIVITY_LOGS_SUCCESS](state, action) {
    return resolveState(state, {
      usersActivityLogs: resolveState(
        state.usersActivityLogs,
        {
          isLoading: false,
          error: null,
          res: action.payload
        }
      )
    });
  },
  [GET_WITHDRAWAL_CATEGORY_SUCCESS](state, action) {
    return resolveState(state, {
      loading: false,
      withdrawalLimitCategoryInfo: action.payload,
      error: null
    })
  },
  [GET_WITHDRAWAL_CATEGORY_ERROR](state, action) {
    return resolveState(state, {
      loading: false,
      withdrawalLimitCategoryInfo: null,
      error: action.payload
    })
  },
  [GET_WITHDRAWAL_CATEGORY_LOADING](state, action) {
    return resolveState(state, {
      loading: true,
      withdrawalLimitCategoryInfo: null,
      error: null
    })
  },
  [GET_WITHDRAWAL_CATEGORIES_ERROR](state, action) {
    return resolveState(state, {
      loading: false,
      withdrawalLimitCategories: null,
      error: action.payload
    })
  },
  [GET_WITHDRAWAL_CATEGORIES_LOADING](state, action) {
    return resolveState(state, {
      loading: true,
      withdrawalLimitCategories: null,
    })
  },
  [GET_WITHDRAWAL_CATEGORIES_SUCCESS](state, action) {
    return resolveState(state, {
      loading: false,
      withdrawalLimitCategories: action.payload,
      createWithdrawalLimitCategorySuccess: null,

    })
  },
  [CREATE_WITHDRAWAL_CATEGORY_ERROR](state, action) {
    return resolveState(state, {
      loading: false,
      createWithdrawalLimitCategorySuccess: null,
      createWithdrawalLimitCategoryError: action.payload
    })
  },
  [CREATE_WITHDRAWAL_CATEGORY_LOADING](state, action) {
    return resolveState(state, {
      loading: true,
      createWithdrawalLimitCategorySuccess: null,
      createWithdrawalLimitCategoryError: null
    })
  },
  [CREATE_WITHDRAWAL_CATEGORY_SUCCESS](state, action) {
    return resolveState(state, {
      loading: false,
      createWithdrawalLimitCategorySuccess: action.payload,
      createWithdrawalLimitCategoryError: null
    })
  },
  [UPDATE_WITHDRAWAL_CATEGORY_ERROR](state, action) {
    return resolveState(state, {
      updateWithdrawalLimitCategory: null,
      updateWithdrawalLimitCategoryError: action.payload,
      loading: false,
    })
  },
  [UPDATE_WITHDRAWAL_CATEGORY_LOADING](state, action) {
    return resolveState(state, {
      updateWithdrawalLimitCategory: null,
      updateWithdrawalLimitCategoryError: null,
      loading: true,
    })
  },
  [UPDATE_WITHDRAWAL_CATEGORY_SUCCESS](state, action) {
    return resolveState(state, {
      updateWithdrawalLimitCategory: action.payload,
      updateWithdrawalLimitCategoryError: null,
      loading: false,
    })
  },
  [DELETE_WITHDRAWAL_CATEGORY_ERROR](state, action) {
    return resolveState(state, {
      deleteWithdrawalLimitCategoryError: action.payload,
      loading: false,
      deleteWithdrawalLimitCategorySuccess: null
    })
  },
  [DELETE_WITHDRAWAL_CATEGORY_LOADING](state, action) {
    return resolveState(state, {
      loading: true,
      deleteWithdrawalLimitCategoryError: null,
      deleteWithdrawalLimitCategorySuccess: null
    })
  },
  [DELETE_WITHDRAWAL_CATEGORY_SUCCESS](state, action) {
    return resolveState(state, {
      deleteWithdrawalLimitCategorySuccess: action.payload,
      loading: false,
      deleteWithdrawalLimitCategoryError: null
    })
  },
  [UPDATE_COMPANY_PAYMENT_SUCCESS](state, action) {
    return Object.assign({}, state, {
      updateCompanyPaymentLoading: false,
      updateCompanyPaymentSuccess: action.payload,
      updateCompanyPaymentError: null
    })
  },
  [UPDATE_COMPANY_PAYMENT_ERROR](state, action) {
    return Object.assign({}, state, {
      updateCompanyPaymentLoading: false,
      updateCompanyPaymentSuccess: null,
      updateCompanyPaymentError: action.payload
    })
  },
  [UPDATE_COMPANY_PAYMENT_LOADING](state, action) {
    return Object.assign({}, state, {
      updateCompanyPaymentLoading: action.payload,
      updateCompanyPaymentSuccess: null,
      updateCompanyPaymentError: null
    })
  },
  [GET_PAYMENTS_COUNT_SUCCESS](state, action) {
    return Object.assign({}, state, {
      paymentCountNoLoading: false,
      paymentCountNo: action.payload,
      paymentCountNoError: null
    })
  },
  [GET_PAYMENTS_COUNT_ERROR](state, action) {
    return Object.assign({}, state, {
      paymentCountNoLoading: false,
      paymentCountNo: 0,
      paymentCountNoError: action.payload
    })
  },
  [GET_PAYMENTS_COUNT_LOADING](state, action) {
    return Object.assign({}, state, {
      paymentCountNoLoading: action.payload,
      paymentCountNo: 0,
      paymentCountNoError: null
    })
  },
  [DASHBOARD_LOADING_ACTION](state, action) {
    return Object.assign({}, state, {
      loading: action.payload
    })
  },
  [SIGN_OUT_SUCCESS](state, action) {
    return Object.assign({}, state, {
      overviewFilters: null,
      withdrawalRequestsFilters: null,
      overtimeRequestsFilters: null,
    });
  },
  [PAYMENT_LIST_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      success: null,
      paymentList: [],
      error: null,
    });
  },
  [PAYMENT_LIST_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      paymentList: action.payload,
      error: null,
    });
  },
  [PAYMENT_LIST_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      paymentList: [],
      error: action.payload,
    });
  },
  [DOWNLOAD_EMPLOYEE_STATEMENT_LOADING](state) {
    return Object.assign({}, state, {
      downloadEmployeeStatementLoading: true,
      downloadEmployeeStatementSuccess: null,
      downloadEmployeeStatementError: null,
    });
  },
  [DOWNLOAD_EMPLOYEE_STATEMENT_SUCCESS](state, action) {
    return Object.assign({}, state, {
      downloadEmployeeStatementLoading: false,
      downloadEmployeeStatementSuccess: action.payload,
      downloadEmployeeStatementError: null,
    });
  },
  [DOWNLOAD_EMPLOYEE_STATEMENT_ERROR](state, action) {
    return Object.assign({}, state, {
      downloadEmployeeStatementLoading: false,
      downloadEmployeeStatementSuccess: null,
      downloadEmployeeStatementError: action.payload,
    });
  },
  [PAYMENT_DOWNLOAD_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      success: null,
      csv: null,
      filename: null,
      error: null,
    });
  },
  [PAYMENT_DOWNLOAD_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      csv: action.payload,
      filename: action.filename,
      error: null,
    });
  },
  [PAYMENT_DOWNLOAD_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      csv: null,
      filename: null,
      error: action.payload,
    });
  },
  [GET_PAYMENT_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      success: null,
      paymentInfo: null,
      error: null,
    });
  },
  [GET_PAYMENT_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      paymentInfo: action.payload,
      error: null,
    });
  },
  [GET_PAYMENT_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      paymentInfo: null,
      error: action.payload,
    });
  },
  [SETTLE_PAYMENT_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      success: null,
      error: null,
    });
  },
  [SETTLE_PAYMENT_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      success: action.payload,
      error: null,
    });
  },
  [SETTLE_PAYMENT_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      success: null,
      error: action.payload,
    });
  },
  [SETTLE_SALARY_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      success: null,
      error: null,
    });
  },
  [SETTLE_SALARY_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      success: action.payload,
      error: null,
    });
  },
  [SETTLE_SALARY_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      success: null,
      error: action.payload,
    });
  },
  [BULK_SETTLE_SALARY_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      success: null,
      error: null,
    });
  },
  [BULK_SETTLE_SALARY_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      success: action.payload,
      error: null,
    });
  },
  [BULK_SETTLE_SALARY_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      success: null,
      error: action.payload,
    });
  },
  [MONTHS_TO_SETTLE_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      success: null,
      monthsToSettle: [],
      error: null,
    });
  },
  [MONTHS_TO_SETTLE_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      monthsToSettle: action.payload,
      error: null,
    });
  },
  [MONTHS_TO_SETTLE_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      monthsToSettle: [],
      error: action.payload,
    });
  },
  [BULK_MONTHS_TO_SETTLE_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      success: null,
      bulkMonthsToSettle: [],
      error: null,
    });
  },
  [BULK_MONTHS_TO_SETTLE_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      bulkMonthsToSettle: action.payload,
      error: null,
    });
  },
  [BULK_MONTHS_TO_SETTLE_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      bulkMonthsToSettle: [],
      error: action.payload,
    });
  },
  [COMPANY_LIST_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      success: null,
      companyList: null,
      error: null,
    });
  },
  [COMPANY_LIST_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      companyList: action.payload,
      error: null,
    });
  },
  [COMPANY_LIST_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      companyList: null,
      error: action.payload,
    });
  },
  [GET_COMPANY_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      success: null,
      companyInfo: null,
      error: null,
    });
  },
  [GET_COMPANY_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      companyInfo: action.payload,
      error: null,
    });
  },
  [GET_COMPANY_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      companyInfo: null,
      error: action.payload,
    });
  },
  [EMPLOYEE_LIST_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      success: null,
      employeeList: [],
      error: null,
    });
  },
  [EMPLOYEE_LIST_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      employeeList: action.payload,
      error: null,
    });
  },
  [EMPLOYEE_LIST_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      employeeList: [],
      error: action.payload,
    });
  },
  [GET_EMPLOYEE_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      success: null,
      employeeInfo: null,
      error: null,
    });
  },
  [GET_EMPLOYEE_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      employeeInfo: action.payload,
      error: null,
    });
  },
  [GET_EMPLOYEE_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      employeeInfo: null,
      error: action.payload,
    });
  },
  [OVERVIEW_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      companyOverview: null,
      error: null,
    });
  },
  [OVERVIEW_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      companyOverview: action.payload,
      error: null,
    });
  },
  [OVERVIEW_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      companyOverview: null,
      error: action.payload,
    });
  },
  [INVITE_COMPANY_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      success: null,
      inviteCompanyError: null,
    });
  },
  [INVITE_COMPANY_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      success: action.payload,
      inviteCompanyError: null,
    });
  },
  [INVITE_COMPANY_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      success: null,
      inviteCompanyError: action.payload,
    });
  },
  [UPDATE_COMPANY_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      success: null,
      error: null,
    });
  },
  [UPDATE_COMPANY_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      success: action.payload,
      error: null,
    });
  },
  [UPDATE_COMPANY_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      success: null,
      error: action.payload,
    });
  },
  [EXCHANGE_LIST_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      success: null,
      exchangeList: [],
      exchangeInfo: null,
      createExchangeSuccess: null,
      createExchangeError: null,
      updateExchangeSuccess: null,
      updateExchangeError: null,
      deleteExchangeSuccess: null,
      deleteExchangeError: null,
      error: null,
    });
  },
  [EXCHANGE_LIST_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      exchangeList: action.payload,
      error: null,
    });
  },
  [EXCHANGE_LIST_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      exchangeList: [],
      error: action.payload,
    });
  },
  [GET_EXCHANGE_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      success: null,
      exchangeInfo: null,
      error: null,
    });
  },
  [GET_EXCHANGE_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      exchangeInfo: action.payload,
      error: null,
    });
  },
  [GET_EXCHANGE_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      exchangeInfo: null,
      error: action.payload,
    });
  },
  [CREATE_EXCHANGE_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      createExchangeSuccess: null,
      createExchangeError: null,
    });
  },
  [CREATE_EXCHANGE_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      createExchangeSuccess: action.payload,
      createExchangeError: null,
    });
  },
  [CREATE_EXCHANGE_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      createExchangeSuccess: null,
      createExchangeError: action.payload,
    });
  },
  [UPDATE_EXCHANGE_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      updateExchangeSuccess: null,
      updateExchangeError: null,
    });
  },
  [UPDATE_EXCHANGE_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      updateExchangeSuccess: action.payload,
      updateExchangeError: null,
    });
  },
  [UPDATE_EXCHANGE_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      updateExchangeSuccess: null,
      updateExchangeError: action.payload,
    });
  },
  [DELETE_EXCHANGE_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      deleteExchangeSuccess: null,
      deleteExchangeError: null,
    });
  },
  [DELETE_EXCHANGE_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      deleteExchangeSuccess: action.payload,
      deleteExchangeError: null,
    });
  },
  [DELETE_EXCHANGE_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      deleteExchangeSuccess: null,
      deleteExchangeError: action.payload,
    });
  },
  [BACKOFFICE_DEDUCTION_LIST_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      success: null,
      deductionList: [],
      deductionInfo: null,
      createDeductionSuccess: null,
      createDeductionError: null,
      updateDeductionSuccess: null,
      updateDeductionError: null,
      deleteDeductionSuccess: null,
      deleteDeductionError: null,
      error: null,
    });
  },
  [BACKOFFICE_DEDUCTION_LIST_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      deductionList: action.payload,
      error: null,
    });
  },
  [BACKOFFICE_DEDUCTION_LIST_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      deductionList: [],
      error: action.payload,
    });
  },
  [GET_DEDUCTION_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      success: null,
      deductionInfo: null,
      error: null,
    });
  },
  [GET_DEDUCTION_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      deductionInfo: action.payload,
      error: null,
    });
  },
  [GET_DEDUCTION_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      deductionInfo: null,
      error: action.payload,
    });
  },
  [CREATE_DEDUCTION_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      createDeductionSuccess: null,
      createDeductionError: null,
    });
  },
  [CREATE_DEDUCTION_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      createDeductionSuccess: action.payload,
      createDeductionError: null,
    });
  },
  [CREATE_DEDUCTION_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      createDeductionSuccess: null,
      createDeductionError: action.payload,
    });
  },
  [UPDATE_DEDUCTION_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      updateDeductionSuccess: null,
      updateDeductionError: null,
    });
  },
  [UPDATE_DEDUCTION_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      updateDeductionSuccess: action.payload,
      updateDeductionError: null,
    });
  },
  [UPDATE_DEDUCTION_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      updateDeductionSuccess: null,
      updateDeductionError: action.payload,
    });
  },
  [DELETE_DEDUCTION_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      deleteDeductionSuccess: null,
      deleteDeductionError: null,
    });
  },
  [DELETE_DEDUCTION_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      deleteDeductionSuccess: action.payload,
      deleteDeductionError: null,
    });
  },
  [DELETE_DEDUCTION_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      deleteDeductionSuccess: null,
      deleteDeductionError: action.payload,
    });
  },
  /* ------------------------------ Bonuses ------------------------------- */
  [BONUS_LIST_LOADING](state) {
    return Object.assign({}, state, {
      bonusListLoading: true,
      bonusListError: null,
    });
  },
  [BONUS_LIST_SUCCESS](state, action) {
    return Object.assign({}, state, {
      bonusListLoading: false,
      bonusList: action.payload,
      bonusListError: null,
    });
  },
  [BONUS_LIST_ERROR](state, action) {
    return Object.assign({}, state, {
      bonusListLoading: false,
      bonusListError: action.payload,
    });
  },
  [GET_BONUS_LOADING](state) {
    return Object.assign({}, state, {
      bonusInfoLoading: true,
      bonusInfoError: null,
    });
  },
  [GET_BONUS_SUCCESS](state, action) {
    return Object.assign({}, state, {
      bonusInfoLoading: false,
      bonusInfo: action.payload,
      bonusInfoError: null,
    });
  },
  [GET_BONUS_ERROR](state, action) {
    return Object.assign({}, state, {
      bonusInfoLoading: false,
      bonusInfo: null,
      bonusInfoError: action.payload,
    });
  },
  [CREATE_BONUS_LOADING](state) {
    return Object.assign({}, state, {
      bonusMutationLoading: true,
      createBonusSuccess: null,
      createBonusError: null,
      bonusFormFieldErrors: null,
    });
  },
  [CREATE_BONUS_SUCCESS](state, action) {
    return Object.assign({}, state, {
      bonusMutationLoading: false,
      createBonusSuccess: action.payload,
      createBonusError: null,
      bonusFormFieldErrors: null,
    });
  },
  [CREATE_BONUS_ERROR](state, action) {
    return Object.assign({}, state, {
      bonusMutationLoading: false,
      createBonusSuccess: null,
      createBonusError: action.payload,
      bonusFormFieldErrors: action.fieldErrors || null,
    });
  },
  [UPDATE_BONUS_LOADING](state) {
    return Object.assign({}, state, {
      bonusMutationLoading: true,
      updateBonusSuccess: null,
      updateBonusError: null,
      bonusFormFieldErrors: null,
    });
  },
  [UPDATE_BONUS_SUCCESS](state, action) {
    return Object.assign({}, state, {
      bonusMutationLoading: false,
      updateBonusSuccess: action.payload,
      updateBonusError: null,
      bonusFormFieldErrors: null,
    });
  },
  [UPDATE_BONUS_ERROR](state, action) {
    return Object.assign({}, state, {
      bonusMutationLoading: false,
      updateBonusSuccess: null,
      updateBonusError: action.payload,
      bonusFormFieldErrors: action.fieldErrors || null,
    });
  },
  [DELETE_BONUS_LOADING](state) {
    return Object.assign({}, state, {
      bonusMutationLoading: true,
      deleteBonusSuccess: null,
      deleteBonusError: null,
    });
  },
  [DELETE_BONUS_SUCCESS](state, action) {
    return Object.assign({}, state, {
      bonusMutationLoading: false,
      deleteBonusSuccess: action.payload,
      deleteBonusError: null,
    });
  },
  [DELETE_BONUS_ERROR](state, action) {
    return Object.assign({}, state, {
      bonusMutationLoading: false,
      deleteBonusSuccess: null,
      deleteBonusError: action.payload,
    });
  },
  /* ------------------------------- Claims ------------------------------- */
  [BONUS_CLAIM_LIST_LOADING](state) {
    return Object.assign({}, state, {
      bonusClaimListLoading: true,
      bonusClaimListError: null,
    });
  },
  [BONUS_CLAIM_LIST_SUCCESS](state, action) {
    return Object.assign({}, state, {
      bonusClaimListLoading: false,
      bonusClaimList: action.payload,
      bonusClaimListError: null,
    });
  },
  [BONUS_CLAIM_LIST_ERROR](state, action) {
    return Object.assign({}, state, {
      bonusClaimListLoading: false,
      bonusClaimListError: action.payload,
    });
  },
  [GET_BONUS_CLAIM_LOADING](state) {
    return Object.assign({}, state, {
      bonusClaimInfoLoading: true,
      bonusClaimInfoError: null,
    });
  },
  [GET_BONUS_CLAIM_SUCCESS](state, action) {
    return Object.assign({}, state, {
      bonusClaimInfoLoading: false,
      bonusClaimInfo: action.payload,
      bonusClaimInfoError: null,
    });
  },
  [GET_BONUS_CLAIM_ERROR](state, action) {
    return Object.assign({}, state, {
      bonusClaimInfoLoading: false,
      bonusClaimInfo: null,
      bonusClaimInfoError: action.payload,
    });
  },
  [DELETE_BONUS_CLAIM_LOADING](state) {
    return Object.assign({}, state, {
      deleteBonusClaimLoading: true,
      deleteBonusClaimSuccess: null,
      deleteBonusClaimError: null,
    });
  },
  [DELETE_BONUS_CLAIM_SUCCESS](state, action) {
    return Object.assign({}, state, {
      deleteBonusClaimLoading: false,
      deleteBonusClaimSuccess: action.payload,
      deleteBonusClaimError: null,
    });
  },
  [DELETE_BONUS_CLAIM_ERROR](state, action) {
    return Object.assign({}, state, {
      deleteBonusClaimLoading: false,
      deleteBonusClaimSuccess: null,
      deleteBonusClaimError: action.payload,
    });
  },
  /* ---------------------------- Role Groups ---------------------------- */
  [PERMISSION_CATALOGUE_LOADING](state) {
    return Object.assign({}, state, {
      permissionCatalogueLoading: true,
      permissionCatalogueError: null,
    });
  },
  [PERMISSION_CATALOGUE_SUCCESS](state, action) {
    return Object.assign({}, state, {
      permissionCatalogueLoading: false,
      permissionCatalogue: Array.isArray(action.payload) ? action.payload : [],
      permissionCatalogueError: null,
    });
  },
  [PERMISSION_CATALOGUE_ERROR](state, action) {
    return Object.assign({}, state, {
      permissionCatalogueLoading: false,
      permissionCatalogueError: action.payload,
    });
  },
  [GROUP_LIST_LOADING](state) {
    return Object.assign({}, state, {
      groupListLoading: true,
      groupListError: null,
    });
  },
  [GROUP_LIST_SUCCESS](state, action) {
    return Object.assign({}, state, {
      groupListLoading: false,
      groupList: action.payload,
      groupListError: null,
    });
  },
  [GROUP_LIST_ERROR](state, action) {
    return Object.assign({}, state, {
      groupListLoading: false,
      groupListError: action.payload,
    });
  },
  [GET_GROUP_LOADING](state) {
    return Object.assign({}, state, {
      groupDetailLoading: true,
      groupDetailError: null,
    });
  },
  [GET_GROUP_SUCCESS](state, action) {
    return Object.assign({}, state, {
      groupDetailLoading: false,
      groupDetail: action.payload,
      groupDetailError: null,
    });
  },
  [GET_GROUP_ERROR](state, action) {
    return Object.assign({}, state, {
      groupDetailLoading: false,
      groupDetail: null,
      groupDetailError: action.payload,
    });
  },
  [CREATE_GROUP_LOADING](state) {
    return Object.assign({}, state, {
      groupMutationLoading: true,
      createGroupSuccess: null,
      createGroupError: null,
      groupFormFieldErrors: null,
    });
  },
  [CREATE_GROUP_SUCCESS](state, action) {
    return Object.assign({}, state, {
      groupMutationLoading: false,
      createGroupSuccess: action.payload,
      createGroupError: null,
      groupFormFieldErrors: null,
    });
  },
  [CREATE_GROUP_ERROR](state, action) {
    return Object.assign({}, state, {
      groupMutationLoading: false,
      createGroupSuccess: null,
      createGroupError: action.payload,
      groupFormFieldErrors: action.fieldErrors || null,
    });
  },
  [UPDATE_GROUP_LOADING](state) {
    return Object.assign({}, state, {
      groupMutationLoading: true,
      updateGroupSuccess: null,
      updateGroupError: null,
      groupFormFieldErrors: null,
    });
  },
  [UPDATE_GROUP_SUCCESS](state, action) {
    return Object.assign({}, state, {
      groupMutationLoading: false,
      updateGroupSuccess: action.payload,
      updateGroupError: null,
      groupFormFieldErrors: null,
    });
  },
  [UPDATE_GROUP_ERROR](state, action) {
    return Object.assign({}, state, {
      groupMutationLoading: false,
      updateGroupSuccess: null,
      updateGroupError: action.payload,
      groupFormFieldErrors: action.fieldErrors || null,
    });
  },
  [DELETE_GROUP_LOADING](state) {
    return Object.assign({}, state, {
      groupMutationLoading: true,
      deleteGroupSuccess: null,
      deleteGroupError: null,
    });
  },
  [DELETE_GROUP_SUCCESS](state, action) {
    return Object.assign({}, state, {
      groupMutationLoading: false,
      deleteGroupSuccess: action.payload,
      deleteGroupError: null,
    });
  },
  [DELETE_GROUP_ERROR](state, action) {
    return Object.assign({}, state, {
      groupMutationLoading: false,
      deleteGroupSuccess: null,
      deleteGroupError: action.payload,
    });
  },
  /* --------------------------- Group members --------------------------- */
  [GROUP_MEMBER_LIST_LOADING](state) {
    return Object.assign({}, state, {
      groupMembersLoading: true,
      groupMembersError: null,
    });
  },
  [GROUP_MEMBER_LIST_SUCCESS](state, action) {
    return Object.assign({}, state, {
      groupMembersLoading: false,
      groupMembersList: action.payload,
      groupMembersError: null,
    });
  },
  [GROUP_MEMBER_LIST_ERROR](state, action) {
    return Object.assign({}, state, {
      groupMembersLoading: false,
      groupMembersError: action.payload,
    });
  },
  [ADD_GROUP_MEMBERS_LOADING](state) {
    return Object.assign({}, state, {
      memberMutationLoading: true,
      addMembersSuccess: null,
      addMembersError: null,
    });
  },
  [ADD_GROUP_MEMBERS_SUCCESS](state, action) {
    // Success payload is the FULL updated member array — rebuild the list from it.
    if (Array.isArray(action.payload)) {
      return Object.assign({}, state, {
        memberMutationLoading: false,
        addMembersSuccess: true,
        addMembersError: null,
        groupMembersList: {
          count: action.payload.length,
          next: null,
          previous: null,
          data: action.payload,
        },
      });
    }
    // Reset path (payload null): only clear the success flag.
    return Object.assign({}, state, { addMembersSuccess: action.payload || null });
  },
  [ADD_GROUP_MEMBERS_ERROR](state, action) {
    return Object.assign({}, state, {
      memberMutationLoading: false,
      addMembersSuccess: null,
      addMembersError: action.payload,
    });
  },
  [REMOVE_GROUP_MEMBERS_LOADING](state) {
    return Object.assign({}, state, {
      memberMutationLoading: true,
      removeMembersSuccess: null,
      removeMembersError: null,
    });
  },
  [REMOVE_GROUP_MEMBERS_SUCCESS](state, action) {
    if (Array.isArray(action.payload)) {
      return Object.assign({}, state, {
        memberMutationLoading: false,
        removeMembersSuccess: true,
        removeMembersError: null,
        groupMembersList: {
          count: action.payload.length,
          next: null,
          previous: null,
          data: action.payload,
        },
      });
    }
    return Object.assign({}, state, { removeMembersSuccess: action.payload || null });
  },
  [REMOVE_GROUP_MEMBERS_ERROR](state, action) {
    return Object.assign({}, state, {
      memberMutationLoading: false,
      removeMembersSuccess: null,
      removeMembersError: action.payload,
    });
  },
  /* ------------------------- Notifications ------------------------------- */
  [NOTIFICATION_COUNT_SUCCESS](state, action) {
    const p = action.payload || {};
    return Object.assign({}, state, {
      notificationCount: {
        unread: Number(p.unread) || 0,
        total: Number(p.total) || 0,
      },
    });
  },
  [NOTIFICATION_COUNT_ERROR](state) {
    // Non-fatal: keep the last known badge count.
    return state;
  },
  [NOTIFICATION_LIST_LOADING](state) {
    return Object.assign({}, state, {
      notificationListLoading: true,
      notificationListError: null,
    });
  },
  [NOTIFICATION_LIST_SUCCESS](state, action) {
    const incoming = action.payload || {};
    // Items may arrive under `results` or `data` — read either, store one.
    const readItems = (env) =>
      Array.isArray(env?.results)
        ? env.results
        : Array.isArray(env?.data)
          ? env.data
          : [];
    const key =
      Array.isArray(incoming.data) && !Array.isArray(incoming.results)
        ? "data"
        : "results";
    let items = readItems(incoming);
    if (action.append && state.notificationList) {
      // Infinite scroll: append the next page, de-duping by id.
      const existing = readItems(state.notificationList);
      const seen = new Set(existing.map((n) => n && n.id));
      items = existing.concat(items.filter((n) => n && !seen.has(n.id)));
    }
    const nextList = Object.assign({}, incoming, { [key]: items });
    // Keep exactly one items key so consumers read the merged list.
    if (key === "data") delete nextList.results;
    else delete nextList.data;
    return Object.assign({}, state, {
      notificationListLoading: false,
      notificationList: nextList,
      notificationListError: null,
    });
  },
  [NOTIFICATION_LIST_ERROR](state, action) {
    return Object.assign({}, state, {
      notificationListLoading: false,
      notificationListError: action.payload,
    });
  },
  [MARK_NOTIFICATION_READ_SUCCESS](state, action) {
    const updated = action.payload;
    if (!updated || !updated.id) return state;
    const list = state.notificationList;
    // The list endpoint may use `results` or `data` for its items — handle both.
    const key =
      list && Array.isArray(list.data) && !Array.isArray(list.results)
        ? "data"
        : "results";
    const items = list ? list[key] || [] : [];
    let wasUnread = false;
    const nextItems = items.map((n) => {
      if (n.id === updated.id) {
        if (!n.is_read) wasUnread = true;
        return Object.assign({}, n, updated);
      }
      return n;
    });
    const nextList = list ? Object.assign({}, list, { [key]: nextItems }) : list;
    const unread = Math.max(
      0,
      (state.notificationCount?.unread || 0) - (wasUnread ? 1 : 0)
    );
    return Object.assign({}, state, {
      notificationList: nextList,
      notificationCount: Object.assign({}, state.notificationCount, { unread }),
    });
  },
  [MARK_ALL_NOTIFICATIONS_READ_SUCCESS](state) {
    const list = state.notificationList;
    const now = new Date().toISOString();
    let nextList = list;
    if (list) {
      const key =
        Array.isArray(list.data) && !Array.isArray(list.results)
          ? "data"
          : "results";
      const items = (list[key] || []).map((n) =>
        Object.assign({}, n, { is_read: true, read_at: n.read_at || now })
      );
      nextList = Object.assign({}, list, { [key]: items });
    }
    return Object.assign({}, state, {
      notificationList: nextList,
      notificationCount: Object.assign({}, state.notificationCount, { unread: 0 }),
    });
  },
  [OVERVIEW_FILTER_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      overviewFilters: action.payload,
    });
  },
  [TRANSACTIONS_WITHDRAWAL_REQUESTS_FILTER_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      withdrawalRequestsFilters: action.payload,
    });
  },
  [TRANSACTIONS_OVERTIME_REQUESTS_FILTER_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      overtimeRequestsFilters: action.payload,
    });
  },
  [TRANSACTION_HISTORY_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      transactionHistory: [],
      error: null,
    });
  },
  [TRANSACTION_HISTORY_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      transactionHistory: action.payload,
      error: null,
    });
  },
  [TRANSACTION_HISTORY_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      transactionHistory: [],
      error: action.payload,
    });
  },
  [BACKOFFICE_COUNTRY_FEES_LIST_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      countryFeesList: [],
      createCountryFeesSuccess: null,
      createCountryFeesError: null,
      updateCountryFeesSuccess: null,
      updateCountryFeesError: null,
      error: null,
    });
  },
  [BACKOFFICE_COUNTRY_FEES_LIST_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      countryFeesList: action.payload,
      error: null,
    });
  },
  [BACKOFFICE_COUNTRY_FEES_LIST_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      countryFeesList: [],
      error: action.payload,
    });
  },
  [CREATE_COUNTRY_FEES_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      createCountryFeesSuccess: null,
      createCountryFeesError: null,
    });
  },
  [CREATE_COUNTRY_FEES_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      createCountryFeesSuccess: action.payload,
      createCountryFeesError: null,
    });
  },
  [CREATE_COUNTRY_FEES_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      createCountryFeesSuccess: null,
      createCountryFeesError: action.payload,
    });
  },
  [UPDATE_COUNTRY_FEES_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      updateCountryFeesSuccess: null,
      updateCountryFeesError: null,
    });
  },
  [UPDATE_COUNTRY_FEES_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      updateCountryFeesSuccess: action.payload,
      updateCountryFeesError: null,
    });
  },
  [UPDATE_COUNTRY_FEES_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      updateCountryFeesSuccess: null,
      updateCountryFeesError: action.payload,
    });
  },
  [PAYMENT_SUB_TABLE_LIST_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
    });
  },
  [PAYMENT_SUB_TABLE_LIST_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      paymentSubTableList: action.payload,
      paymentSubTableListError: null,
      paymentSubTablePage: action.page
    })
  },
  [PAYMENT_SUB_TABLE_LIST_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      paymentSubTableListError: action.payload,
      paymentSubTableList: []
    });
  },
  [DECLINE_PAYMENT_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      success: null,
      error: null,
    });
  },
  [DECLINE_PAYMENT_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      success: action.payload,
      error: null,
    });
  },
  [DECLINE_PAYMENT_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      success: null,
      error: action.payload,
    });
  },
  [GET_REPORTS_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      success: null,
      error: null,
    })
  },
  [GET_REPORTS_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      reportAnalysisData: action.payload,
      error: null
    })
  },
  [GET_REPORTS_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      success: null,
      error: action.payload,
    });
  },
  [PUSH_NOTIFICATION_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      success: null,
      error: null
    })
  },
  [PUSH_NOTFICATION_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      success: action.payload,
      error: null
    })
  },
  [PUSH_NOTIFICATION_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      error: action.payload,
      success: null
    })
  },
  [SEND_MONTHLY_COMPANY_REPORTS_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      companyMonthlyReportsSuccess: null,
      companyMonthlyReportsError: null
    })
  },
  [SEND_MONTHLY_COMPANY_REPORTS_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      companyMonthlyReportsSuccess: action.payload,
      companyMonthlyReportsError: null
    })
  },
  [SEND_MONTHLY_COMPANY_REPORTS_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      companyMonthlyReportsSuccess: null,
      companyMonthlyReportsError: action.payload
    })
  },
  [SEND_CUSTOM_COMPANY_REPORTS_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      companyCustomReportsSuccess: null,
      companyCustomReportsError: null
    })
  },
  [SEND_CUSTOM_COMPANY_REPORTS_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      companyCustomReportsSuccess: action.payload,
      companyCustomReportsError: null
    })
  },
  [SEND_CUSTOM_COMPANY_REPORTS_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      companyCustomReportsSuccess: null,
      companyCustomReportsError: action.payload
    })
  },
  [MERCHANT_LIST_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      merchantList: null,
      error: null,
    });
  },
  [MERCHANT_LIST_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      merchantList: action.payload,
      error: null,
    });
  },
  [MERCHANT_LIST_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      merchantList: null,
      error: action.payload,
    });
  },
  [GET_MERCHANT_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      merchantInfo: null,
      error: null,
    });
  },
  [GET_MERCHANT_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      merchantInfo: action.payload,
      error: null,
    });
  },
  [GET_MERCHANT_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      merchantInfo: null,
      error: action.payload,
    });
  },
  [GET_VENDOR_PAYMENTS_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      vendorPayments: null,
      error: null,
    });
  },
  [GET_VENDOR_PAYMENTS_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      vendorPayments: action.payload,
      error: null,
    });
  },
  [GET_VENDOR_PAYMENTS_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      vendorPayments: null,
      error: action.payload,
    });
  },
  [GET_VENDOR_FEES_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      vendorFees: null,
      error: null,
    });
  },
  [GET_VENDOR_FEES_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      vendorFees: action.payload,
      error: null,
    });
  },
  [GET_VENDOR_FEES_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      vendorFees: null,
      error: action.payload,
    });
  },
  [CREATE_VENDOR_FEES_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      createVendorFeesSuccess: null,
      createVendorFeesError: null,
    });
  },
  [CREATE_VENDOR_FEES_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      createVendorFeesSuccess: action.payload,
      createVendorFeesError: null,
    });
  },
  [CREATE_VENDOR_FEES_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      createVendorFeesSuccess: null,
      createVendorFeesError: action.payload,
    });
  },
  [UPDATE_VENDOR_FEES_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      updateVendorFeesSuccess: null,
      updateVendorFeesError: null,
    });
  },
  [UPDATE_VENDOR_FEES_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      updateVendorFeesSuccess: action.payload,
      updateVendorFeesError: null,
    });
  },
  [UPDATE_VENDOR_FEES_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      updateVendorFeesSuccess: null,
      updateVendorFeesError: action.payload,
    });
  },
  [DELETE_VENDOR_FEES_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      deleteVendorFeesSuccess: null,
      deleteVendorFeesError: null,
    });
  },
  [DELETE_VENDOR_FEES_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      deleteVendorFeesSuccess: action.payload,
      deleteVendorFeesError: null,
    });
  },
  [DELETE_VENDOR_FEES_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      deleteVendorFeesSuccess: null,
      deleteVendorFeesError: action.payload,
    });
  },
  [GET_COMPANY_FEES_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      companyFees: null,
      error: null,
    });
  },
  [GET_COMPANY_FEES_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      companyFees: action.payload,
      error: null,
    });
  },
  [GET_COMPANY_FEES_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      companyFees: null,
      error: action.payload,
    });
  },
  [CREATE_COMPANY_FEES_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      createCompanyFeesSuccess: null,
      createCompanyFeesError: null,
    });
  },
  [CREATE_COMPANY_FEES_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      createCompanyFeesSuccess: action.payload,
      createCompanyFeesError: null,
    });
  },
  [CREATE_COMPANY_FEES_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      createCompanyFeesSuccess: null,
      createCompanyFeesError: action.payload,
    });
  },
  [UPDATE_COMPANY_FEES_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      updateCompanyFeesSuccess: null,
      updateCompanyFeesError: null,
    });
  },
  [UPDATE_COMPANY_FEES_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      updateCompanyFeesSuccess: action.payload,
      updateCompanyFeesError: null,
    });
  },
  [UPDATE_COMPANY_FEES_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      updateCompanyFeesSuccess: null,
      updateCompanyFeesError: action.payload,
    });
  },
  [DELETE_COMPANY_FEES_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      deleteCompanyFeesSuccess: null,
      deleteCompanyFeesError: null,
    });
  },
  [DELETE_COMPANY_FEES_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      deleteCompanyFeesSuccess: action.payload,
      deleteCompanyFeesError: null,
    });
  },
  [DELETE_COMPANY_FEES_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      deleteCompanyFeesSuccess: null,
      deleteCompanyFeesError: action.payload,
    });
  },
  [GET_VENDOR_SETTLEMENTS_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      vendorSettlements: {
        count: 0,
        next: null,
        previous: null,
        data: [],
      },
      error: null,
    });
  },
  [GET_VENDOR_SETTLEMENTS_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      vendorSettlements: {
        count: action.payload.count || 0,
        next: action.payload.next || null,
        previous: action.payload.previous || null,
        data: action.payload.data || [],
      },
      error: null,
    });
  },
  [GET_VENDOR_SETTLEMENTS_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      vendorSettlements: {
        count: 0,
        next: null,
        previous: null,
        data: [],
      },
      error: action.payload,
    });
  },
  [INVITE_MERCHANT_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      inviteMerchantSuccess: null,
      inviteMerchantError: null,
    });
  },
  [INVITE_MERCHANT_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      inviteMerchantSuccess: action.payload,
      inviteMerchantError: null,
      success: action.payload,
    });
  },
  [INVITE_MERCHANT_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      inviteMerchantSuccess: null,
      inviteMerchantError: action.payload,
      error: action.payload,
    });
  },
  [UPDATE_MERCHANT_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      updateMerchantSuccess: null,
      updateMerchantError: null,
    });
  },
  [UPDATE_MERCHANT_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      updateMerchantSuccess: action.payload,
      updateMerchantError: null,
      success: action.payload,
    });
  },
  [UPDATE_MERCHANT_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      updateMerchantSuccess: null,
      updateMerchantError: action.payload,
      error: action.payload,
    });
  },
  [REACTIVATE_VENDOR_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      reactivateVendorSuccess: null,
      reactivateVendorError: null,
    });
  },
  [REACTIVATE_VENDOR_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      reactivateVendorSuccess: action.payload,
      reactivateVendorError: null,
      success: action.payload,
    });
  },
  [REACTIVATE_VENDOR_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      reactivateVendorSuccess: null,
      reactivateVendorError: action.payload,
      error: action.payload,
    });
  },
  [SUSPEND_VENDOR_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      suspendVendorSuccess: null,
      suspendVendorError: null,
    });
  },
  [SUSPEND_VENDOR_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      suspendVendorSuccess: action.payload,
      suspendVendorError: null,
      success: action.payload,
    });
  },
  [SUSPEND_VENDOR_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      suspendVendorSuccess: null,
      suspendVendorError: action.payload,
      error: action.payload,
    });
  },
  [CAMPAIGN_CONFIG_REQUEST_LOADING](state) {
    return resolveState(state, {
      campaigns: resolveState(state.campaigns, { configLoading: true, error: null }),
    });
  },
  [CAMPAIGN_CONFIG_REQUEST_SUCCESS](state, action) {
    return resolveState(state, {
      campaigns: resolveState(state.campaigns, {
        configLoading: false,
        config: action.payload,
        error: null,
      }),
    });
  },
  [CAMPAIGN_CONFIG_REQUEST_ERROR](state, action) {
    return resolveState(state, {
      campaigns: resolveState(state.campaigns, {
        configLoading: false,
        error: action.payload,
      }),
    });
  },
  [CAMPAIGN_LIST_REQUEST_LOADING](state) {
    return resolveState(state, {
      campaigns: resolveState(state.campaigns, { listLoading: true, error: null }),
    });
  },
  [CAMPAIGN_LIST_REQUEST_SUCCESS](state, action) {
    return resolveState(state, {
      campaigns: resolveState(state.campaigns, {
        listLoading: false,
        list: action.payload || { count: 0, next: null, previous: null, data: [] },
      }),
    });
  },
  [CAMPAIGN_LIST_REQUEST_ERROR](state, action) {
    return resolveState(state, {
      campaigns: resolveState(state.campaigns, {
        listLoading: false,
        list: { count: 0, next: null, previous: null, data: [] },
        error: action.payload,
      }),
    });
  },
  [CAMPAIGN_DETAIL_REQUEST_LOADING](state) {
    return resolveState(state, {
      campaigns: resolveState(state.campaigns, { detailLoading: true, error: null }),
    });
  },
  [CAMPAIGN_DETAIL_REQUEST_SUCCESS](state, action) {
    return resolveState(state, {
      campaigns: resolveState(state.campaigns, {
        detailLoading: false,
        detail: action.payload,
      }),
    });
  },
  [CAMPAIGN_DETAIL_REQUEST_ERROR](state, action) {
    return resolveState(state, {
      campaigns: resolveState(state.campaigns, {
        detailLoading: false,
        detail: null,
        error: action.payload,
      }),
    });
  },
  [CAMPAIGN_CREATE_REQUEST_LOADING](state) {
    return resolveState(state, {
      campaigns: resolveState(state.campaigns, {
        saveLoading: true,
        formErrors: null,
        error: null,
        toast: null,
      }),
    });
  },
  [CAMPAIGN_CREATE_REQUEST_SUCCESS](state, action) {
    return resolveState(state, {
      campaigns: resolveState(state.campaigns, {
        saveLoading: false,
        detail: action.payload,
        formErrors: null,
        toast: { type: "success", message: "Campaign created successfully" },
      }),
    });
  },
  [CAMPAIGN_CREATE_REQUEST_ERROR](state, action) {
    return resolveState(state, {
      campaigns: resolveState(state.campaigns, {
        saveLoading: false,
        formErrors: action.payload,
        error: action.payload,
        toast: { type: "error", message: "Failed to create campaign" },
      }),
    });
  },
  [CAMPAIGN_UPDATE_REQUEST_LOADING](state) {
    return resolveState(state, {
      campaigns: resolveState(state.campaigns, {
        saveLoading: true,
        formErrors: null,
        error: null,
        toast: null,
      }),
    });
  },
  [CAMPAIGN_UPDATE_REQUEST_SUCCESS](state, action) {
    return resolveState(state, {
      campaigns: resolveState(state.campaigns, {
        saveLoading: false,
        detail: action.payload,
        formErrors: null,
        toast: { type: "success", message: "Campaign updated successfully" },
      }),
    });
  },
  [CAMPAIGN_UPDATE_REQUEST_ERROR](state, action) {
    return resolveState(state, {
      campaigns: resolveState(state.campaigns, {
        saveLoading: false,
        formErrors: action.payload,
        error: action.payload,
        toast: { type: "error", message: "Failed to update campaign" },
      }),
    });
  },
  [CAMPAIGN_ACTION_REQUEST_LOADING](state) {
    return resolveState(state, {
      campaigns: resolveState(state.campaigns, {
        actionLoading: true,
        error: null,
        toast: null,
      }),
    });
  },
  [CAMPAIGN_ACTION_REQUEST_SUCCESS](state, action) {
    return resolveState(state, {
      campaigns: resolveState(state.campaigns, {
        actionLoading: false,
        toast: { type: "success", message: action?.payload?.message || "Campaign action completed" },
      }),
    });
  },
  [CAMPAIGN_ACTION_REQUEST_ERROR](state, action) {
    return resolveState(state, {
      campaigns: resolveState(state.campaigns, {
        actionLoading: false,
        error: action.payload,
        toast: { type: "error", message: "Campaign action failed" },
      }),
    });
  },
  [CAMPAIGN_STATS_REQUEST_LOADING](state) {
    return resolveState(state, {
      campaigns: resolveState(state.campaigns, { statsLoading: true, error: null }),
    });
  },
  [CAMPAIGN_STATS_REQUEST_SUCCESS](state, action) {
    return resolveState(state, {
      campaigns: resolveState(state.campaigns, { statsLoading: false, stats: action.payload }),
    });
  },
  [CAMPAIGN_STATS_REQUEST_ERROR](state, action) {
    return resolveState(state, {
      campaigns: resolveState(state.campaigns, {
        statsLoading: false,
        stats: null,
        error: action.payload,
      }),
    });
  },
  [CAMPAIGN_HISTORY_REQUEST_LOADING](state) {
    return resolveState(state, {
      campaigns: resolveState(state.campaigns, { historyLoading: true, error: null }),
    });
  },
  [CAMPAIGN_HISTORY_REQUEST_SUCCESS](state, action) {
    return resolveState(state, {
      campaigns: resolveState(state.campaigns, {
        historyLoading: false,
        history: action.payload || { count: 0, next: null, previous: null, data: [] },
      }),
    });
  },
  [CAMPAIGN_HISTORY_REQUEST_ERROR](state, action) {
    return resolveState(state, {
      campaigns: resolveState(state.campaigns, {
        historyLoading: false,
        history: { count: 0, next: null, previous: null, data: [] },
        error: action.payload,
      }),
    });
  },
  [CAMPAIGN_SET_FILTERS_SUCCESS](state, action) {
    return resolveState(state, {
      campaigns: resolveState(state.campaigns, {
        filters: resolveState(state.campaigns.filters, action.payload || {}),
      }),
    });
  },
  [CAMPAIGN_SET_PAGINATION_SUCCESS](state, action) {
    return resolveState(state, {
      campaigns: resolveState(state.campaigns, {
        pagination: resolveState(state.campaigns.pagination, action.payload || {}),
      }),
    });
  },
  [CAMPAIGN_SET_HISTORY_PAGINATION_SUCCESS](state, action) {
    return resolveState(state, {
      campaigns: resolveState(state.campaigns, {
        historyPagination: resolveState(state.campaigns.historyPagination, action.payload || {}),
      }),
    });
  },
  [CAMPAIGN_RESET_FORM_ERRORS_SUCCESS](state) {
    return resolveState(state, {
      campaigns: resolveState(state.campaigns, {
        formErrors: null,
        error: null,
      }),
    });
  },
  [CAMPAIGN_CLEAR_TOAST_SUCCESS](state) {
    return resolveState(state, {
      campaigns: resolveState(state.campaigns, {
        toast: null,
      }),
    });
  },
});
